module.exports = "/_next/static/images/949bcc269c4acf8b49ec96f32908dcba-wellDone.svg";